import { render, staticRenderFns } from "./TitleForm.vue?vue&type=template&id=c0c80caa"
import script from "./TitleForm.vue?vue&type=script&lang=js"
export * from "./TitleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports